export default __webpack_public_path__ + "static/media/avatar_bg_madara.5f04d1e8.png";